"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiDropWithoutWavesPageWithoutCount } from "@/generated/models/ApiDropWithoutWavesPageWithoutCount";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { generateUniqueKeys, mapToExtendedDrops } from "@/helpers/waves/wave-drops.helpers";
import { commonApiFetch } from "@/services/api/common-api";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";
const toWaveMin = (wave: ApiWave): ApiWaveMin => {
  return {
    id: wave.id,
    name: wave.name,
    picture: wave.picture,
    description_drop_id: wave.description_drop.id,
    authenticated_user_eligible_to_vote: wave.voting.authenticated_user_eligible,
    authenticated_user_eligible_to_participate: wave.participation.authenticated_user_eligible,
    authenticated_user_eligible_to_chat: wave.chat.authenticated_user_eligible,
    authenticated_user_admin: wave.wave.authenticated_user_eligible_for_admin,
    visibility_group_id: wave.visibility.scope.group?.id ?? null,
    participation_group_id: wave.participation.scope.group?.id ?? null,
    chat_group_id: wave.chat.scope.group?.id ?? null,
    voting_group_id: wave.voting.scope.group?.id ?? null,
    admin_group_id: wave.wave.admin_group.group?.id ?? null,
    voting_period_start: wave.voting.period?.min ?? null,
    voting_period_end: wave.voting.period?.max ?? null,
    voting_credit_type: wave.voting.credit_type,
    admin_drop_deletion_enabled: wave.wave.admin_drop_deletion_enabled,
    forbid_negative_votes: wave.voting.forbid_negative_votes,
    pinned: wave.pinned
  };
};
export function useWaveDropsSearch(t0) {
  const $ = _c(24);
  const {
    wave,
    term,
    enabled,
    size: t1
  } = t0;
  const size = t1 === undefined ? 50 : t1;
  let t2;
  if ($[0] !== term) {
    t2 = term.trim();
    $[0] = term;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const trimmedTerm = t2;
  let t3;
  if ($[2] !== wave) {
    t3 = wave ? toWaveMin(wave) : null;
    $[2] = wave;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const waveMin = t3;
  const t4 = wave?.id ?? null;
  let t5;
  if ($[4] !== size || $[5] !== t4 || $[6] !== trimmedTerm) {
    t5 = [QueryKey.DROPS, {
      waveId: t4,
      term: trimmedTerm,
      size,
      context: "wave-search"
    }];
    $[4] = size;
    $[5] = t4;
    $[6] = trimmedTerm;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = enabled && wave !== null && trimmedTerm.length > 0;
  let t7;
  if ($[8] !== size || $[9] !== trimmedTerm || $[10] !== wave) {
    t7 = async t8 => {
      const {
        pageParam
      } = t8;
      return await commonApiFetch({
        endpoint: `waves/${wave.id}/search`,
        params: {
          term: trimmedTerm,
          page: String(pageParam),
          size: String(size)
        }
      });
    };
    $[8] = size;
    $[9] = trimmedTerm;
    $[10] = wave;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = {
      queryKey: t5,
      enabled: t6,
      initialPageParam: 1,
      queryFn: t7,
      getNextPageParam: _temp,
      staleTime: 30000
    };
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const query = useInfiniteQuery(t8);
  query.data?.pages;
  let t9;
  if ($[16] !== query.data?.pages || $[17] !== waveMin) {
    bb0: {
      if (!waveMin) {
        let t10;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = [];
          $[19] = t10;
        } else {
          t10 = $[19];
        }
        t9 = t10;
        break bb0;
      }
      const all = query.data?.pages.flatMap(_temp2) ?? [];
      if (all.length === 0) {
        let t10;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = [];
          $[20] = t10;
        } else {
          t10 = $[20];
        }
        t9 = t10;
        break bb0;
      }
      const mapped = mapToExtendedDrops([{
        wave: waveMin,
        drops: all
      }], [], false);
      t9 = generateUniqueKeys(mapped, []);
    }
    $[16] = query.data?.pages;
    $[17] = waveMin;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const drops = t9;
  let t10;
  if ($[21] !== drops || $[22] !== query) {
    t10 = {
      ...query,
      drops
    };
    $[21] = drops;
    $[22] = query;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp2(page) {
  return page.data;
}
function _temp(lastPage) {
  return lastPage.next ? lastPage.page + 1 : undefined;
}